import api from '@/services/api'
import { camelToSnake } from '../../../utils/object'

export default class OrganizationAPI {
  static ORGANIZATIONS_ENDPOINT = 'organizations'

  /**
   * Initialize a `OrganizationAPI` instance.
   *
   * @param {class} cls  The class to use to create Organization objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `OrganizationAPI`.
   *
   * @param {class} cls      The class to use to create Organization objects.
   **/
  static create(cls) {
    return new OrganizationAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one Organization from the API.
   *
   * @param {String} organizationID  Unique ID of the Organization to retrieve.
   */
  get(organizationID) {
    const url = `${OrganizationAPI.ORGINIZATIONS_ENDPOINT}/${organizationID}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Create a Organization via the API.
   */
  create(organization, fields = []) {
    const url = `${OrganizationAPI.ORGANIZATIONS_ENDPOINT}/`
    const data = this.cls.toAPI(organization, fields)
    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
  }

  /**
   * Get all Organizations through the API.
   *
   *
   */
  list({ filters = {} } = {}) {
    const url = `${OrganizationAPI.ORGANIZATIONS_ENDPOINT}/`
    const options = {
      params: {},
    }

    // Filters

    if (filters.pageSize) {
      options.params.page_size = filters.pageSize
    }

    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a Organization through the API.
   *
   * @param {Organization} organization  Organization data to send to the API.
   */
  update(organization, fields = [], excludeFields = []) {
    const url = `${OrganizationAPI.ORGANIZATIONS_ENDPOINT}/${organization.id}/`
    const data = this.cls.toAPI(organization, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Register a new Organization through the API.
   *
   * @param {Object} data   Object with the fields required for registration.
   */
  register(data) {
    return this.client
      .post(`${OrganizationAPI.ORGANIZATIONS_ENDPOINT}/`, camelToSnake(data))
      .then(response => this.cls.fromAPI(response.data))
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('Register Organization API error')
        throw error
      })
  }
}
